<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import TtButton from '@/components/TtButton.vue'
import { useAccountStore } from '@/store/account'
import { storeToRefs } from 'pinia'
import { formattedAddress } from '@/utils/location'

const { user } = storeToRefs(useAccountStore())

const { t } = useI18n({ useScope: 'global' })

const locationHeadings = ref<String[]>([
  t('tools.id'),
  t('tools.type'),
  t('tools.location'),
  ''
])

const locations = ref(user.value?.locations ?? [])

const types = {
  paid_parking: t('location.types.paid_parking'),
  parking: t('location.types.free_parking')
}
</script>

<template>
  <div>
    <h2 class="text-2xl font-semibold">{{ t('tools.my-locations') }}</h2>

    <table
      class="w-full table-auto border-separate border-spacing-y-3 text-tt-gray"
    >
      <thead>
        <tr>
          <th
            v-for="item in locationHeadings"
            class="p-2 text-left text-base font-medium first:px-4"
          >
            {{ item }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="location in locations.slice().reverse()"
          :key="location.id"
          class=""
        >
          <td class="rounded-s-lg bg-white px-4 py-2">
            {{ location.id?.substring(24) }}
          </td>
          <td class="bg-white p-2">
            {{ location.dataset ? types[location.dataset] : '' }}
          </td>
          <td class="bg-white p-2">
            <span class="inline-block w-96 max-w-full truncate">{{
              location.name === formattedAddress(location)
                ? formattedAddress(location)
                : `${location.name} (${formattedAddress(location)})`
            }}</span>
          </td>
          <td class="bg-white p-2 text-right">
            <TtButton
              :as="'router-link'"
              :to="{ name: 'edit-location', params: { id: location.id } }"
              :size="'xsmall'"
              :type="'tertiary'"
            >
              {{ t('tools.edit') }}
            </TtButton>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
